import { render, staticRenderFns } from "./ToolsProperties.vue?vue&type=template&id=451931d7&scoped=true&"
import script from "./ToolsProperties.vue?vue&type=script&lang=js&"
export * from "./ToolsProperties.vue?vue&type=script&lang=js&"
import style0 from "./ToolsProperties.vue?vue&type=style&index=0&id=451931d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451931d7",
  null
  
)

export default component.exports